import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Text, Td, Tr } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { useStore } from '../../hooks/useStore';
import CustomTable from '../../components/table/CustomTable';
import { eventHeaders } from '../../constants/tableHeaders';
import { FlashListingsEvent } from '../../constants/types';

const EventsScreen: React.FC = () => {
  const {
    listingStore: {
      getListingEventGroups,
      flashListingsEvents,
      loading,
      setCurrentFlashEvent,
    },
  } = useStore();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const fetchEvents = async () => {
    await getListingEventGroups();
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const formatDateTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleString();
  };

  const handleRowClick = (event: FlashListingsEvent) => {
    setCurrentFlashEvent(event);
    navigate(`/dashboard/events/${event.timeGroup}/${event.groupId}`);
  };

  const renderEventRow = (event: FlashListingsEvent, index: number) => (
    <Tr
      key={`${event.timeGroup}-${index}`}
      onClick={() => handleRowClick(event)}
      cursor="pointer"
    >
      <Td>
        <Text isTruncated maxWidth="250px" title={event.title}>
          {event.title}
        </Text>
      </Td>
      <Td>{event.total}</Td>
      <Td>{formatDateTime(event.metaTimes[0])}</Td>
      <Td>{formatDateTime(event.metaTimes[event.metaTimes.length - 1])}</Td>
    </Tr>
  );

  return (
    <Box p={6}>
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        Flash Listing Events
      </Text>

      <CustomTable
        headers={eventHeaders}
        rowsPerPage={rowsPerPage}
        totalRows={flashListingsEvents.length}
        fetchDataTable={fetchEvents}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        loading={loading}
      >
        {flashListingsEvents.map((event, index) =>
          renderEventRow(event, index),
        )}
      </CustomTable>
    </Box>
  );
};

export default observer(EventsScreen);
